// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_18Ugc","rotator":"_24A4x","path":"_2la0t","dash":"_1sQ6f"};